import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/professional/new',
  title: 'Cadastrar profissional',
  endpoint: '',
}
